import React, { Component } from "react";
import "./App.css";
import CardList from "./components/CardList";
import { getCourses } from "./api.js";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      courses: null
    };
  }

  componentDidMount() {
    getCourses()
      .then(courses => {
        this.setState({ courses });
      })
      .catch(error => console.error(error));
  }

  render() {
    const { courses } = this.state;
    if (!courses) {
      return null;
    }

    return (
      <div className="page">
        <CardList courses={courses} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js